import { isAppVisible } from '@mews/std';
import { ApplicationState } from '@mews-commander/types';
import { anonymizeUrl, getTomorrowLocalizedDate, utcToLocalizedDate } from '@mews-commander/utils';
import { trackEvent } from '../../../middleware/createAnalyticsMiddleware';
import { navigateInBaseModal } from '../../app/actions/common';

const EVENT_CATEGORY = 'Dashboard';

export const shouldFetch =
    (
        isLoadedSelector: (state: ApplicationState) => boolean,
        lastModifiedSelector: (state: ApplicationState) => number,
        maxAge: number
    ) =>
    (state: ApplicationState, now: number) =>
        !isLoadedSelector(state) || (now - lastModifiedSelector(state) > maxAge && isAppVisible());

export const redirectInModal = (url: $TSFixMe) => (dispatch: $TSFixMe) => {
    dispatch(trackEvent({ eventCategory: EVENT_CATEGORY, eventAction: 'link clicked', eventLabel: anonymizeUrl(url) }));
    dispatch(navigateInBaseModal(url));
};

export const trackDashboardPieClick = (pieType: $TSFixMe) => (dispatch: $TSFixMe) => {
    dispatch(trackEvent({ eventCategory: EVENT_CATEGORY, eventAction: 'pie chart link clicked', eventLabel: pieType }));
};

export const getTaskReportIndexQueryParams = (timezone: string, nowUtc: string, startUtc: string) => ({
    Custom: true,
    'End.Date': getTomorrowLocalizedDate(nowUtc, timezone),
    'Start.Date': utcToLocalizedDate(startUtc, timezone),
    'State.Open': true,
    'State.Closed': false,
    Filter: 'Deadline',
});
